module.exports = __webpack_public_path__ + "img/save.9d8cf8ff.svg";